import axios from 'axios'
import moment from 'moment'
// import store from '../..'

const setListRecordExam = ({ commit }, payload) => {
  if (!payload.patient) return false
  const { patient, customer } = payload
  console.log('payload', payload)
  return new Promise((resolve, reject) => {
    axios.get(`${process.env.URL}/my-clinic-new/patient/examination-report`, {
      params: {
        customer: customer, // store.state.customer,
        patient: patient
      }
    })
      .then(function (response) {
        // handle success
        let items = []
        if (response && response.data && response.data.results && response.data.results.results) {
          items = response.data.results.results.map((item) => {
            return {
              date: moment(item.tbData, 'YYYY/MM/DD').format('DD/MM'),
              hour: moment(item.tbHora, 'LTS').format('HH'),
              doctor: item.tbNomeMedico === null ? '' : item.tbNomeMedico.substring(0, 10),
              history: item.tbDescricao
            }
          })
        }
        resolve(commit('SET_LISTRECORDEXAM', items))
      })
      .catch(function (error) {
        // handle error
        console.error('err', error)
        reject(error)
      })
      .then(function () {
        // always executed
      })
  })
}

const setCreateRecordExam = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    const { doctor, patient, customer, date, record, description } = payload
    axios.post(`${process.env.URL}/my-clinic-new/examination-report/create`, {
      doctor: doctor,
      patient: patient,
      date: date,
      record: record,
      description: description
    }, {
      params: {
        customer: customer
      }
    }).then((response) => {
      resolve(commit('SET_LISTRECORDEXAM', response))
    }).catch((err) => {
      window.console.error('errologin', err)
      reject(err)
    })
  })
}

export default {
  setListRecordExam,
  setCreateRecordExam
}



// WEBPACK FOOTER //
// ./src/store/modules/examination-report/actions.js